import { useApp } from "../context/AppContext";
import PRODUCTS, { NEW_ARRIVAL_IDS } from "../data/products";
import CategoryCards from "../components/CategoryCards";
import SectionHeader from "../components/SectionHeader";
import ProductGrid   from "../components/ProductGrid";

const INFO_ITEMS = [
  { icon: "🕐", text: "Open 7 Days a Week" },
  { icon: "📍", text: "London ON" },
  { icon: "📞", text: "###-###-####" },
  { icon: "✈️", text: "Rare American Imports" },
];

export default function HomePage() {
  const { navigate, setSearch } = useApp();

  const goTo = (cat) => {
    setSearch("");
    navigate("products", cat);
  };

  const newArrivals  = PRODUCTS.filter((p) => NEW_ARRIVAL_IDS.includes(p.id));
  const energyDrinks = PRODUCTS.filter((p) => p.cat === "energy").slice(0, 4);
  const candies      = PRODUCTS.filter((p) => p.cat === "candies").slice(0, 4);

  return (
    <div className="fade-up">

      {/* ── Hero Banner ── */}
      <div className="hero-banner">
        <div className="hero-text">
          <div className="hero-eyebrow">Est. 2014 · London, Ontario</div>
          <h1 className="hero-title">
            Your <em>Local</em><br />Variety Store
          </h1>
          <p className="hero-desc">
            From rare American imports to fireworks — Private's has something for
            everyone!
          </p>
          <button className="hero-cta" onClick={() => goTo("all")}>
            Shop All Products →
          </button>
        </div>
        <div className="hero-emojis">
          {["🥤", "🍬", "🎆", "⚡"].map((emoji) => (
            <div key={emoji} className="hero-emoji-bubble">{emoji}</div>
          ))}
        </div>
      </div>

      {/* ── Info Strip ── */}
      <div className="info-strip">
        <div className="info-strip-inner">
          {INFO_ITEMS.map(({ icon, text }) => (
            <div key={text} className="info-pill">
              <span className="info-pill-icon">{icon}</span>
              <span>{text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Page content ── */}
      <div className="page-wrap">

        {/* Category Cards */}
        <SectionHeader
          title="Shop by Category"
          onSeeAll={() => goTo("all")}
        />
        <CategoryCards />

        {/* New Arrivals */}
        <SectionHeader
          title="✨ New Arrivals"
          onSeeAll={() => goTo("new")}
        />
        <div style={{ marginBottom: 48 }}>
          <ProductGrid products={newArrivals} />
        </div>

        {/* Energy Drinks */}
        <SectionHeader
          title="⚡ Energy Drinks"
          onSeeAll={() => goTo("energy")}
        />
        <div style={{ marginBottom: 48 }}>
          <ProductGrid products={energyDrinks} />
        </div>

        {/* Candies */}
        <SectionHeader
          title="🍬 Popular Candies"
          onSeeAll={() => goTo("candies")}
        />
        <ProductGrid products={candies} />

      </div>
    </div>
  );
}
